import React from "react";
import SubLink from '../../Route/SubLink';
import {WareHouseData} from '../../Route/SubLinkJSON';

function Warehouse() {
  return (
    <div>
   <SubLink sublinks={WareHouseData} />
    </div>
  );
}

export default Warehouse;
